import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import {
  CheckboxFilterDropdownPanel,
  GradeFilterButton,
  GradeFilterCaretIcon,
  GradeFilterOption,
  GradeFilterOptionLabel,
  GradeFilterWrap,
} from './component.styles'

const CheckboxDropdownFilter = ({
  buttonLabel,
  dataTestId,
  idPrefix,
  onToggle,
  options,
  selectedKeys,
}) => {
  const [open, setOpen] = useState(false)
  const wrapRef = useRef(null)

  const selection =
    selectedKeys instanceof Set
      ? selectedKeys
      : Array.isArray(selectedKeys)
      ? new Set(selectedKeys)
      : new Set()

  useEffect(() => {
    if (!open) return undefined
    const close = e => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', close)
    return () => document.removeEventListener('mousedown', close)
  }, [open])

  useEffect(() => {
    if (!open) return undefined
    const onKey = e => {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open])

  const selectedCount = options.filter(o => selection.has(o)).length
  const showPartialSelectionSuffix =
    selectedCount > 0 && selectedCount < options.length

  return (
    <GradeFilterWrap ref={wrapRef}>
      <GradeFilterButton
        $isOpen={open}
        aria-expanded={open}
        aria-haspopup="true"
        data-testid={dataTestId}
        onClick={() => setOpen(o => !o)}
        type="button"
      >
        <span>
          {buttonLabel}
          {showPartialSelectionSuffix
            ? ` (${selectedCount}/${options.length})`
            : ''}
        </span>
        <GradeFilterCaretIcon $open={open} aria-hidden>
          <path d="M11 1L6 6L1 1" />
        </GradeFilterCaretIcon>
      </GradeFilterButton>
      {open && (
        <CheckboxFilterDropdownPanel role="group">
          {options.map(optionLabel => (
            <GradeFilterOption
              htmlFor={`${idPrefix}-${optionLabel}`}
              key={optionLabel}
            >
              <input
                checked={selection.has(optionLabel)}
                id={`${idPrefix}-${optionLabel}`}
                onChange={() => onToggle(optionLabel)}
                type="checkbox"
              />
              <GradeFilterOptionLabel>{optionLabel}</GradeFilterOptionLabel>
            </GradeFilterOption>
          ))}
        </CheckboxFilterDropdownPanel>
      )}
    </GradeFilterWrap>
  )
}

CheckboxDropdownFilter.propTypes = {
  buttonLabel: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
  idPrefix: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedKeys: PropTypes.oneOfType([
    PropTypes.instanceOf(Set),
    PropTypes.arrayOf(PropTypes.string),
  ]),
}

export default CheckboxDropdownFilter
